/**
 * A cart may not span markets. A localization form switching market empties the
 * cart before it submits.
 *
 * Document-level rather than per-form: nothing else on this storefront posts
 * country_code, and the switchers sit inside overlays that mount late.
 *
 * Not covered: the stores-menu links inside the region switcher. Those render
 * as <a href> (input-checkbox `as: 'a'`, header-v2.liquid:502) and navigate
 * without a submit event. Whether they need covering depends on where they
 * point: another store has its own cart and nothing to clear, a market on this
 * store does not. Ticket #424.
 *
 * Call sites must use requestSubmit(). form.submit() fires no submit event
 * and slips past this entirely.
 */
(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.elements) return;

      var field = form.elements.country_code;
      if (!field) return;

      // RadioNodeList with nothing checked reads "" -> not a switch
      var next = field.value;
      if (!next) return;

      var root = document.documentElement.dataset;

      /**
       * The switchers stamp the target market, because the country they post is
       * the market's pinned representative rather than the visitor's own. On a
       * country compare, a Dutch visitor picking Europe (German) posts DE against
       * a current NL and reads as a market switch, emptying the cart on what is
       * only a language change.
       *
       * No stamp -> fall back to countries. That can over-clear inside a market,
       * never under-clear across one, which is the safe direction.
       */
      var nextMarket = form.dataset.targetMarket;
      if (nextMarket) {
        if (nextMarket === root.market) return;
      } else if (next === root.country) {
        return;
      }

      event.preventDefault();

      function proceed() {
        form.submit(); // native: fires no submit event, so this does not re-enter
      }

      // Localized: from /en-eu the bare /cart is another market's cart.
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

      // Fail open. A dead cart endpoint must not strand the switcher.
      fetch(cartUrl + '/clear.js', { method: 'POST' }).then(proceed, proceed);
    },
    true
  );
})();
